import React, { Component } from "react";
import { Link } from 'react-router-dom'

import Menu from '../components/Menu'

export default class Header extends Component {

  constructor(props) {
    super(props);
    this.state = { };

  }

  componentDidMount() {}

  render() {

    return (

        <header>
            <Menu/>
        </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.js